import { ca } from '@cian/analytics';
import { PAGE_TYPE } from '../../constants/pageType';
import { getSiteType } from '../../utils/getSiteType';
import { TDeviceType } from '@cian/ui-kit';

export const trackClickBanner = (deviceType: TDeviceType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click',
    label: 'Banner',
    page: {
      pageType: PAGE_TYPE,
      siteType: getSiteType(deviceType),
      extra: {
        banner_location: 'specialists_page',
      },
    },
  });
};
